import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';

const DialogTitleDefault = ({ children, onClose, ...other }) => {
    return (
        <DialogTitle sx={{ m: 0, p: 2,textAlign:'center' }} {...other}>
            {children}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#64748b',
                    background: '#f1f5f9',
                    width: 32,
                    height: 32,
                    '&:hover': {
                        background: '#e2e8f0',
                        color: '#475569'
                    },
                    transition: 'all 0.2s ease'
                }}
            >
                <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>
        </DialogTitle>
    );
}
export default DialogTitleDefault